
import { Injectable } from "@angular/core";
import { Store } from "./store";
import { UserInfoElement, UserInfoState } from "../../models/UserInfo.model";

@Injectable()
export class UserInfoStore extends Store<UserInfoState> {
  constructor() {
    super(new UserInfoState());
  }

  setInfo(data): void {
    var prevState = this.state;
    let currState = Object.assign({}, prevState);
    currState.info = data;
    this.setState(currState);
  }
  setCartInfo(data): void {
    var prevState = this.state;
    let currState = Object.assign({}, prevState);
    currState.cartInfo = data;
    this.setState(currState);
  }
}
